import type { NodePropertyName } from '@salescore/core'
import { Form, Row, Select } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { useCurrentNodeUserReferenceProperties } from '../../../../recoil/view/hooks/kpiForm'
import { useCurrentNodeStringProperties } from '../../../../recoil/view/selectors/kpiFormSelector'
import { PropertySelect } from './PropertySelect'

export const KpiFormUserFormItem = ({
  joinAs,
  setJoinAs,
  userProperty,
  setUserProperty,
}: {
  joinAs: 'id' | 'email' | 'name' | undefined
  setJoinAs: (joinAs: 'id' | 'email' | 'name' | undefined) => void
  userProperty: NodePropertyName | undefined
  setUserProperty: (property: NodePropertyName | undefined) => void
}): ReactElement => {
  const currentNodeStringProperties = useCurrentNodeStringProperties()
  const currentNodeUserReferenceProperties = useCurrentNodeUserReferenceProperties()

  return (
    <Row>
      <Form.Item label={t(`ユーザーの紐付け方法`)} style={{ width: `100%` }}>
        <Select
          allowClear
          value={joinAs}
          onChange={setJoinAs}
          options={[
            {
              label: t(`IDで紐付け`),
              value: 'id',
            },
            {
              label: t(`メールアドレスで紐付け`),
              value: 'email',
            },
            {
              label: t(`名前で紐付け`),
              value: 'name',
            },
          ]}
        />
      </Form.Item>
      {/* eslint-disable-next-line sonarjs/todo-tag */}
      {/* TODO */}
      <Form.Item label={t(`ユーザー項目`)} style={{ width: `100%` }}>
        <PropertySelect
          allowClear
          disabled={joinAs === undefined}
          properties={joinAs === 'id' ? currentNodeUserReferenceProperties : currentNodeStringProperties}
          value={userProperty}
          onChange={setUserProperty}
        />
      </Form.Item>
    </Row>
  )
}
